export const formatMoney = function (x: number, showDecimals = false) {
  return x
    .toFixed(showDecimals ? 2 : 0)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
